import { ForwardedRef, forwardRef, HTMLAttributes } from "react"
import cn from "classnames"

import { Text } from "ui-kit/components-branded/index"
import { Icon } from "components"
import { Item } from "modules/Call/components/HelpMoreMenuWrapper/PopperTooltip"
import style from "modules/Call/components/HelpMoreMenuWrapper/MoreSelectorTooltip/style.module.scss"

interface Props extends HTMLAttributes<HTMLDivElement> {
    items: Item[]
}

export const MoreSelectorTooltip = forwardRef(
    ({ items, className, ...props }: Props, ref: ForwardedRef<HTMLDivElement>) => (
        <div ref={ref} className={cn(style.overlay, className)} {...props}>
            <div className={style.content}>
                {items.map(({ id, label, description, icon, action }) => (
                    <div key={id} className={style.item} onClick={action} onChange={action}>
                        <Icon type={icon} size={25} className={style.icon} />
                        <div>
                            <Text className={style.label}>{label}</Text>
                            <Text className={style.description}>{description}</Text>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
)

MoreSelectorTooltip.displayName = "MoreSelectorTooltip"
